var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-rating',{attrs:{"length":"5","dense":"","color":"teal"},nativeOn:{"click":function($event){return _vm.onClick.apply(null, arguments)}},model:{value:(_vm.model.score),callback:function ($$v) {_vm.$set(_vm.model, "score", $$v)},expression:"model.score"}})
}
var staticRenderFns = []

export { render, staticRenderFns }